import type { AppState } from "store/types";

export const getAllTimersMeta = (state: AppState) =>
  state.application.timersMeta;

export type TimersMetaState = ReturnType<typeof getAllTimersMeta>;
